const ChoroplethMulticolor = require('okCharts/ChoroplethMulticolor/ChoroplethMulticolor');

export default ChoroplethMulticolor;
